(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.getAttribute('data-sticky-type') === 'always' && 'ResizeObserver' in window) {
          this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
          this.headerResizeObserver.observe(this.header);
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magneo-r2-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('magneo-r2-story')) {
    customElements.define('magneo-r2-story', class extends HTMLElement {
      connectedCallback() {
        if (this.magneoR2Controller) return;
        this.magneoR2Controller = new AbortController();
        const signal = this.magneoR2Controller.signal;
        this.magneoR2Steps = Array.from(this.querySelectorAll('[data-magneo-r2-step]'));
        this.magneoR2Index = 0;
        this.magneoR2Previous = this.querySelector('[data-magneo-r2-previous]');
        this.magneoR2Next = this.querySelector('[data-magneo-r2-next]');
        this.magneoR2Count = this.querySelector('[data-magneo-r2-count]');
        this.magneoR2Playback = this.querySelector('[data-magneo-r2-playback]');
        this.magneoR2Motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.magneoR2Playing = !this.magneoR2Motion.matches && !window.Shopify?.designMode;
        this.magneoR2InView = false;
        this.magneoR2Hovered = false;
        const controls = this.querySelector('[data-magneo-r2-controls]');
        const carousel = this.querySelector('[data-magneo-r2-carousel]');
        if (this.magneoR2Steps.length && controls) {
          this.showMagneoR2Step(0);
          controls.hidden = this.magneoR2Steps.length < 2;
          const manualStep = (index) => {
            this.pauseMagneoR2Autoplay();
            this.showMagneoR2Step(index);
          };
          this.magneoR2Previous.addEventListener('click', () => manualStep(this.magneoR2Index - 1), { signal });
          this.magneoR2Next.addEventListener('click', () => manualStep(this.magneoR2Index + 1), { signal });
          carousel.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            manualStep(this.magneoR2Index + (event.key === 'ArrowRight' ? 1 : -1));
          }, { signal });
          let touchOrigin = null;
          carousel.addEventListener('touchstart', (event) => {
            touchOrigin = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          }, { passive: true, signal });
          carousel.addEventListener('touchend', (event) => {
            if (!touchOrigin || event.changedTouches.length !== 1) return;
            const dx = event.changedTouches[0].clientX - touchOrigin.x;
            const dy = event.changedTouches[0].clientY - touchOrigin.y;
            touchOrigin = null;
            if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) manualStep(this.magneoR2Index + (dx < 0 ? 1 : -1));
          }, { passive: true, signal });
          carousel.addEventListener('touchcancel', () => { touchOrigin = null; }, { passive: true, signal });
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.magneoR2Steps.findIndex((step) => step.dataset.blockId === event.detail.blockId);
            if (index >= 0) manualStep(index);
          }, { signal });
          carousel.addEventListener('focusin', (event) => {
            if (!this.magneoR2Playback?.contains(event.target)) this.pauseMagneoR2Autoplay();
          }, { signal });
          carousel.addEventListener('click', (event) => {
            if (!this.magneoR2Playback?.contains(event.target)) this.pauseMagneoR2Autoplay();
          }, { signal });
          carousel.addEventListener('mouseenter', () => { this.magneoR2Hovered = true; this.updateMagneoR2Autoplay(); }, { signal });
          carousel.addEventListener('mouseleave', () => { this.magneoR2Hovered = false; this.updateMagneoR2Autoplay(); }, { signal });
          carousel.addEventListener('load', (event) => {
            if (this.magneoR2Steps[this.magneoR2Index]?.contains(event.target)) this.updateMagneoR2Autoplay();
          }, { capture: true, signal });
          this.magneoR2Playback?.addEventListener('click', () => {
            if (this.magneoR2Playing) this.pauseMagneoR2Autoplay();
            else {
              if (this.magneoR2Index === this.magneoR2Steps.length - 1) this.showMagneoR2Step(0);
              this.magneoR2Playing = true;
              this.magneoR2Hovered = false;
              this.updateMagneoR2Autoplay();
            }
          }, { signal });
          document.addEventListener('visibilitychange', () => this.updateMagneoR2Autoplay(), { signal });
          this.magneoR2Motion.addEventListener('change', () => {
            if (this.magneoR2Motion.matches) this.pauseMagneoR2Autoplay();
          }, { signal });
          if ('IntersectionObserver' in window && this.magneoR2Steps.length > 1) {
            this.magneoR2ViewObserver = new IntersectionObserver(([entry]) => {
              this.magneoR2InView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
              if (this.magneoR2InView) this.magneoR2Steps.forEach(step => {
                const image = step.querySelector('img');
                if (image) image.loading = 'eager';
              });
              this.updateMagneoR2Autoplay();
            }, { threshold: [0, 0.5] });
            this.magneoR2ViewObserver.observe(carousel);
          } else {
            this.magneoR2Playing = false;
            if (this.magneoR2Playback) this.magneoR2Playback.hidden = true;
          }
          this.updateMagneoR2Autoplay();
        }
        this.magneoR2Top = this.querySelector('[data-magneo-r2-top]');
        if (this.magneoR2Top) {
          const update = () => {
            if (this.magneoR2Frame) return;
            this.magneoR2Frame = requestAnimationFrame(() => {
              this.magneoR2Frame = null;
              this.updateMagneoR2Top();
            });
          };
          window.addEventListener('scroll', update, { passive: true, signal });
          window.addEventListener('resize', update, { passive: true, signal });
          document.querySelectorAll('.sticky-atc').forEach((element) => element.addEventListener('transitionend', update, { signal }));
          document.addEventListener('shopify:section:load', update, { signal });
          this.magneoR2Observer = new MutationObserver(update);
          document.querySelectorAll('.scroll-to-top-btn, .sticky-atc').forEach((element) => this.magneoR2Observer.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] }));
          this.magneoR2Top.addEventListener('click', () => {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reduceMotion) this.magneoR2Top.classList.add('magneo-r2__back-top--turning');
            window.scrollTo({ top: 0, behavior: reduceMotion ? 'instant' : 'smooth' });
          }, { signal });
          this.magneoR2Top.addEventListener('animationend', () => this.magneoR2Top.classList.remove('magneo-r2__back-top--turning'), { signal });
          this.updateMagneoR2Top();
        }
      }
      showMagneoR2Step(index) {
        this.magneoR2Index = Math.max(0, Math.min(this.magneoR2Steps.length - 1, index));
        this.magneoR2Steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== this.magneoR2Index; });
        this.magneoR2Count.textContent = this.magneoR2Count.dataset.countTemplate.replace('__CURRENT__', String(this.magneoR2Index + 1));
        this.magneoR2Previous.disabled = this.magneoR2Index === 0;
        this.magneoR2Next.disabled = this.magneoR2Index === this.magneoR2Steps.length - 1;
        if (this.magneoR2Next.disabled) this.magneoR2Playing = false;
        this.updateMagneoR2Autoplay();
      }
      pauseMagneoR2Autoplay() {
        this.magneoR2Playing = false;
        this.updateMagneoR2Autoplay();
      }
      updateMagneoR2Autoplay() {
        clearTimeout(this.magneoR2Timer);
        this.magneoR2Timer = null;
        if (this.magneoR2Playback) {
          const labels = this.magneoR2Playback.dataset;
          this.magneoR2Playback.textContent = this.magneoR2Playing ? labels.pauseLabel : this.magneoR2Index === this.magneoR2Steps.length - 1 ? labels.replayLabel : labels.playLabel;
        }
        const canPlay = this.isConnected && this.magneoR2Playing && this.magneoR2InView && !document.hidden && !this.magneoR2Hovered && this.magneoR2Index < this.magneoR2Steps.length - 1;
        this.magneoR2Count?.setAttribute('aria-live', canPlay ? 'off' : 'polite');
        if (!canPlay) return;
        const image = this.magneoR2Steps[this.magneoR2Index]?.querySelector('img');
        if (image && (!image.complete || !image.naturalWidth)) return;
        this.magneoR2Timer = setTimeout(() => {
          this.magneoR2Timer = null;
          if (!this.isConnected || !this.magneoR2Playing || !this.magneoR2InView || document.hidden || this.magneoR2Hovered) return;
          const nextImage = this.magneoR2Steps[this.magneoR2Index + 1]?.querySelector('img');
          if (nextImage && (!nextImage.complete || !nextImage.naturalWidth)) this.updateMagneoR2Autoplay();
          else this.showMagneoR2Step(this.magneoR2Index + 1);
        }, 5000);
      }
      updateMagneoR2Top() {
        if (!this.isConnected || !this.magneoR2Top) return;
        const visible = (element) => {
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return !element.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
        };
        const originalVisible = Array.from(document.querySelectorAll('.scroll-to-top-btn')).some(visible);
        this.magneoR2Top.hidden = window.scrollY < 400 || originalVisible;
        const stickyHeight = Array.from(document.querySelectorAll('.sticky-atc')).reduce((height, element) => {
          const style = getComputedStyle(element);
          if (element.hidden || style.display === 'none' || style.visibility === 'hidden') return height;
          if (element.classList.contains('sticky-atc--after-scroll') && !element.classList.contains('sticky-atc--active')) return height;
          const rect = element.getBoundingClientRect();
          return Math.max(height, rect.height, Math.max(0, window.innerHeight - rect.top));
        }, 0);
        this.magneoR2Top.style.setProperty('--magneo-r2-sticky-height', `${Math.ceil(stickyHeight)}px`);
      }
      disconnectedCallback() {
        clearTimeout(this.magneoR2Timer);
        this.magneoR2Timer = null;
        this.magneoR2ViewObserver?.disconnect();
        this.magneoR2Controller?.abort();
        this.magneoR2Controller = null;
        this.magneoR2Observer?.disconnect();
        if (this.magneoR2Frame) cancelAnimationFrame(this.magneoR2Frame);
        this.magneoR2Frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
